import { faPen, faTrashCan } from '@fortawesome/pro-light-svg-icons';
import { faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { queryString } from '@olivierpascal/helpers';
import { IconButton, Menu, MenuItem } from '@sixui/ui';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import type { IContainerProps } from '~/components/utils/Container';

export type ICategoryListItemMenuProps = IContainerProps & {
  appId: string;
  categoryId: string;
  isLink?: boolean;
  processing?: boolean;
  handleDelete?: () => void;
};

export const CategoryListItemMenu: React.FC<ICategoryListItemMenuProps> = (
  props,
) => {
  const { sx, appId, categoryId, isLink, processing, handleDelete } = props;
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <Menu
      trigger={({ getProps }) => (
        <IconButton
          icon={<FontAwesomeIcon icon={faEllipsisVertical} />}
          loading={processing}
          {...getProps()}
        />
      )}
      placement="bottom-end"
      sx={sx}
    >
      <MenuItem
        label={t('common.edit')}
        leadingIcon={<FontAwesomeIcon icon={faPen} />}
        href={
          isLink
            ? `/apps/${appId}/links/${categoryId}/update`
            : `/apps/${appId}/categories/${categoryId}/update?${queryString.build({ nextUrl: location.pathname, cancelUrl: location.pathname })}`
        }
      />
      {handleDelete ? (
        <MenuItem
          label={t('common.delete')}
          leadingIcon={<FontAwesomeIcon icon={faTrashCan} />}
          onClick={handleDelete}
          variant="danger"
        />
      ) : null}
    </Menu>
  );
};
